export const CORPORATE_QUOTE_STATUSES = ['DRAFT', 'SENT', 'ACCEPTED', 'DECLINED'] as const;
export type CorporateQuoteStatus = (typeof CORPORATE_QUOTE_STATUSES)[number];

export const CORPORATE_INVOICE_STATUSES = ['ISSUED', 'PAID', 'VOID'] as const;
export type CorporateInvoiceStatus = (typeof CORPORATE_INVOICE_STATUSES)[number];
